<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('roles.title')"></page-header-title>

      <v-spacer></v-spacer>

      <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex">
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                :label="$t('global.search')"
                v-model="search_params.any"
                @keydown="checkKeyPress"
                autocomplete="off"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <router-link
        :to="BACKEND_URL + '/roles/create'"
        v-if="$can('role-create')"
      >
        <action-button type="new" />
      </router-link>

      <!--<action-button type="filter" @click="show_filter = !show_filter"/>-->
    </v-app-bar>

    <!--<v-expansion-panels
            :value="0"
            class="cstm-filter mb-3 elevation-0"
            v-if="show_filter"
            readonly
        >
            <v-expansion-panel>
                <v-expansion-panel-header hide-actions>
                    {{ $t('global.filter') }}
                </v-expansion-panel-header>
                <v-expansion-panel-content class="elevation-1">
                    <v-form ref="form" @submit.prevent="filter">
                        <v-container grid-list-md>
                            <v-layout row wrap>
                                <v-flex md6>
                                    <v-text-field
                                        :label="$t('roles.name')"
                                        v-model="search_params.name"
                                        autocomplete="off"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex md12>
                                    <action-button type="filter" @click="filter" small/>
                                    <action-button type="reset" @click="reset" small/>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>-->

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="roles"
            :items-per-page="roles.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text'),
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            :must-sort="true"
          >
            <template v-slot:item.actions="{ item }">
              <router-link
                :to="{
                  path: BACKEND_URL + '/roles/edit/' + item.id,
                  props: { id: item.id },
                }"
                v-if="$can('role-edit')"
              >
                <action-button type="edit" :icon_only="true" small />
              </router-link>

              <action-button
                type="delete"
                @click="del(item.id)"
                :icon_only="true"
                v-if="$can('role-delete')"
                small
              />
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { ActionButton } from "@brakomp/ui"

export default {
  components: { ActionButton },
  name: "RoleList",

  data() {
    return {
      url: "",
      roles: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage("__page_Role_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["name"],
        sortDesc: [false],
      },
      search_params: {
        any: "",
        name: "",
        type: "",
      },
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("roles.name"), value: "name" },
          { text: this.$t("roles.slug"), value: "slug" },
          {
            text: this.$t("global.actions"),
            value: "actions",
            width: "20%",
            align: "end",
            sortable: false,
          },
        ]
      },
    },
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          this.list()
        }
      },
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (
            _.has(newVal, "sortBy") &&
            _.has(newVal, "sortDesc") &&
            _.has(oldVal, "sortBy") &&
            _.has(oldVal, "sortDesc") &&
            (!_.isEqual(newVal.sortBy, oldVal.sortBy) ||
              !_.isEqual(newVal.sortDesc, oldVal.sortDesc))
          ) {
            let obj = {
              sortBy: this.pagination.sortBy,
              sortDesc: this.pagination.sortDesc,
            }
            localStorage.setItem("__sort_Role_List", JSON.stringify(obj))
          }

          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_Role_List", newVal.page)
          }

          this.refresh = true
        }
      },
    },
  },

  mounted() {
    this.url = this.API_URL + "roles"
  },

  methods: {
    test() {
      this.$globalMessages("global role <br /> global test", "success")
    },

    list() {
      this.show_loading = true

      let localFilter = localStorage.getItem("__filter_Role_List")
      if (localFilter !== null) {
        localFilter = JSON.parse(localFilter)
        this.search_params = localFilter
      }

      let localSort = localStorage.getItem("__sort_Role_List")
      if (localSort !== null) {
        localSort = JSON.parse(localSort)
        this.pagination.sortBy = localSort.sortBy
        this.pagination.sortDesc = localSort.sortDesc
      }

      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.url + "?" + query).then(res => {
        this.roles = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    filter() {
      this.pagination.page = 1
      this.refresh = true
      localStorage.setItem(
        "__filter_Role_List",
        JSON.stringify(this.search_params),
      )
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "role/" + id)
            .then(() => {
              vm.refresh = true
              vm.$store.dispatch("auth/updateUserState", vm)
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch(err => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no"),
          },
        },
      )
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    },
  },
}
</script>

<style scoped></style>
